module.exports = __webpack_public_path__ + "static/marketingTeam@2x-cd45f3d74c8ba7bc4c3c26b1ac1cc28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/marketingTeam@2x.jpg
// module id = 2582
// module chunks = 168707334958949